import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import ClearRoundedIcon from '@mui/icons-material/ClearRounded'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'

import TextInput from '@/components/ui/inputs/TextInput'
import { useState } from 'react'

export type SearchInputProps = {
  onSearch?: (text: string) => void
}

export function SearchInput(props: SearchInputProps) {
  const { onSearch } = props
  const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }

  const handleReset = () => {
    setSearchValue('')
    onSearch?.('')
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    onSearch?.(searchValue)
  }

  return (
    <form onSubmit={handleSubmit}>
      <TextInput
        InputProps={{
          endAdornment: (
            <Stack direction="row">
              {!!searchValue && (
                <IconButton aria-label="clear" onClick={handleReset} size="small">
                  <ClearRoundedIcon fontSize="inherit" />
                </IconButton>
              )}
              <IconButton aria-label="search" type="submit" size="small">
                <SearchRoundedIcon fontSize="inherit" />
              </IconButton>
            </Stack>
          ),
        }}
        onChange={handleChange}
        placeholder={t('page.superAdmin.settings.searchInput.placeholder')}
        value={searchValue}
      />
    </form>
  )
}
